'use client';

import dynamic from 'next/dynamic';

export const SparkleDemoCollection = dynamic(() => import('./Demos'));
export const InitialSparkleDemo = dynamic(() => import('./Initial'));
export const InitialKeyframeSparkleDemo = dynamic(
  () => import('./InitialKeyframe')
);
export const InitialSplitSparkles = dynamic(
  () => import('./InitialSplit')
);
export const SparkleIntervalDemos = dynamic(
  () => import('./IntervalDemos')
);
